import React from "react";
import project1 from '../asset/project1.png';
import project2 from '../asset/project2.png';
import projett3 from '../asset/project3.png';
import project4 from '../asset/project4.png';
import project5 from '../asset/project5.png';
import project6 from '../asset/project6.png';

const Projects = () => {
    return(
        <section id="projects" className="py-20 bg-color2">
                <div className="container mx-auto text-center">
                    <h2 className="text-2xl font-bold mb-8 text-white">My Projects</h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <img src={project1} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-md opacity-60"/>
                            <h3 className="text-2xl font-bold mb-2 text-white">Prototype website game developer</h3>
                            <p className="text-white">Prototype website perusahaan game level infinite</p>
                        </div>

                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <div className="bg-color3 opacity-80">
                                <img src={project2} alt="Samuel Wattimena" className="mx-auto items-center h-48 mb-4 rounded-md opacity-90"/>
                            </div>
                            <h3 className="text-2xl font-bold mb-2 text-white">Login form UI</h3>
                            <p className="text-white">Membuat halaman form untuk login</p>
                        </div>

                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <img src={projett3} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-md opacity-60"/>
                            <h3 className="text-2xl font-bold mb-2 text-white">Login UI music application</h3>
                            <p className="text-white">Mambuat UI login aplikasi music</p>
                        </div>
                        
                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <img src={project4} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-md opacity-60"/>
                            <h3 className="text-2xl font-bold mb-2 text-white">GIF Generator</h3>
                            <p className="text-white">Mambuat system untuk merender random gif</p>
                        </div>

                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <img src={project5} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-md opacity-60"/>
                            <h3 className="text-2xl font-bold mb-2 text-white">Weather APP</h3>
                            <p className="text-white">Mambuat aplikasi untuk mengecek cuaca</p>
                        </div>

                        <div className="bg-color1 p-4 rounded-lg relative hover:shadow-glow3 hover:transition1">
                            <img src={project6} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-md opacity-60"/>
                            <h3 className="text-2xl font-bold mb-2 text-white">Mobile Inventaris Barang APP</h3>
                            <p className="text-white">Mambuat aplikasi inventaris barang untuk mobile</p>
                        </div>
                    </div>

                </div>
        </section>
    )
}

export default Projects;